import { combineReducers, createReducer } from '@reduxjs/toolkit';

import { VehicleWidgetDialogName } from 'Components/names';
import { dialogClosed, dialogOpened, type ExtractorData } from 'Core/actions/dialog';
import {
  forceVehicleSelection,
  vehicleSelected,
  vehicleSpecificationNeeded,
} from 'Core/actions/fitmentSearch/index';
import fitmentSearchConfig from 'Models/uiConfig/fitmentSearchConfig';

const initStates: { extractorData: ExtractorData; opened: string[] } = {
  extractorData: null,
  // Dialogs can open other dialogs. For example, FacetDialog can open
  // SimpleColorPaletteDialog while the facet dialog remains open.
  opened: [],
};

export default combineReducers({
  opened: createReducer(initStates.opened, (builder) =>
    builder
      .addCase(dialogOpened, (state, { payload: name }) => (state.includes(name) ? state : [...state, name]))
      .addCase(dialogClosed, (state, { payload }) => state.filter((name) => name !== payload))
      .addCase(forceVehicleSelection, (state) =>
        state.includes(VehicleWidgetDialogName) ? state : [...state, VehicleWidgetDialogName],
      )
      .addCase(vehicleSpecificationNeeded, (state, { meta: { isolatedKey } }) =>
        isolatedKey === null && !state.includes(VehicleWidgetDialogName)
          ? [...state, VehicleWidgetDialogName]
          : state,
      )
      .addCase(vehicleSelected, (state) =>
        state.filter((name) => !fitmentSearchConfig.vehicleDialogNames.has(name)),
      ),
  ),
  extractorData: createReducer(initStates.extractorData, (builder) =>
    builder
      .addCase(dialogOpened, (state, { meta: { extractorData } }) => extractorData ?? state)
      .addDefaultCase(() => initStates.extractorData),
  ),
});
